import * as React from 'react';

import { RouteProps } from 'react-router';

import Layout, { FooterType, HeaderType } from '../components/common/Layout';

interface ILayoutParams {
  footerType?: FooterType;
  headerType?: HeaderType;
  hideHeaderMobile?: boolean;
}

export default function layoutWrapper<T>(
  ComposedComponent: React.ComponentType<T>,
  params?: ILayoutParams,
) {
  return (props: T & RouteProps) => {
    const { footerType, headerType, hideHeaderMobile } = params || ({} as ILayoutParams);
    return (
      <Layout footerType={footerType} headerType={headerType} hideHeaderMobile={hideHeaderMobile}>
        <ComposedComponent {...props} />
      </Layout>
    );
  };
}
